import { useState } from 'react';

import { YStack } from '@/components/ui/layout/layout';

import { useSignInQrImageQuery } from './sign-in-session.query';

export const CredentialQrImage = ({ fileId }: { fileId: string }) => {
  const { data, isError } = useSignInQrImageQuery(fileId);
  const [imageStatus, setImageStatus] = useState<'loading' | 'ready' | 'error'>(
    'loading'
  );
  const unavailable = isError || imageStatus === 'error';

  return (
    <YStack className="w-full items-center gap-3 text-center">
      {unavailable ? (
        <p
          role="alert"
          className="max-w-xs text-sm leading-relaxed text-foreground-muted"
        >
          Couldn’t load the QR code. You can still choose an option below.
        </p>
      ) : (
        <>
          {imageStatus === 'loading' ? (
            <p role="status" className="text-sm text-foreground-muted">
              Loading QR code…
            </p>
          ) : null}
          {data ? (
            <img
              src={data.url}
              alt="Scan this QR code to sign in"
              className="mx-auto block h-auto w-full max-w-64 self-center rounded-lg border-8 border-white bg-white object-contain"
              onLoad={() => setImageStatus('ready')}
              onError={() => setImageStatus('error')}
            />
          ) : null}
        </>
      )}
    </YStack>
  );
};
